module.exports = __webpack_public_path__ + "img/howard johnson-logo.0690aa21.png";